'use strict';

/* Directives */
angular.module('FlexyBeautyApp.directives').
  directive('appVersion', ['version', function(version) {
    return function(scope, elm, attrs) {
      elm.text(version);
    };
  }])
    .directive('draggableCategory', function() {
        return {
            restrict: 'A',
            link: function(scope, element, attrs) {
                let categoryView = scope[attrs["draggableCategory"]];
                $(element).draggable({
                    distance: 5,
                    revert: "invalid",
                    zIndex: 1000,
                    cursorAt: {top: -5, left: -5},
                    start: function () {
                        if (!categoryView || !categoryView.getModel()) {
                            return false;
                        }
                        // On drag set that flag to not null
                        scope.dd.view.selected.categoryView.draggedCategoryView = categoryView;
                        $("button.selector-btn-edit-image").hide();
                    },
                    stop: function () {
                        scope.dd.view.selected.categoryView.draggedCategoryView = null;
                        $("button.selector-btn-edit-image").show();
                    }
                });
            }
        };
    })
    .directive('draggableService', function() {
        return {
            restrict: 'A',
            link: function(scope, element, attrs) {
                let serviceView = scope[attrs["draggableService"]];
                $(element).draggable({
                        distance: 5,
                        opacity: 0.5,
                        revert: "invalid",
                        zIndex: 10,
                        cursorAt: {top: -5, left: -5},
                        start: function () {
                            if (!serviceView || !serviceView.getModel()) {
                                return false;
                            }
                            // On drag set that flag to not null
                            scope.dd.view.selected.categoryView.draggedServiceView = serviceView;
                        },
                        stop: function () {
                            scope.dd.view.selected.categoryView.draggedServiceView = null;
                        }
                    }
                );
            }
        };
    })
    .directive('draggableProduct',  ["$timeout", function($timeout) {
        return {
            restrict: 'A',
            link: function(scope, element, attrs) {
                var productView = scope[attrs["draggableProduct"]];
                $timeout(function(){
                $(element).draggable({
                        distance: 5,
                        opacity: 0.5,
                        revert: "invalid",
                        zIndex:10,
                        cursorAt: { top:-5,left:-5 },
                        start: function(){
                            if (!productView || !productView.getModel())
                                return false;
                            // On drag set that flag to not null
                            scope.dd.view.selected.categoryView.draggedProductView = productView;

                        },
                        stop:function () {

                            scope.dd.view.selected.categoryView.draggedProductView = null;
                        }
                    }
                );
                },500);

            }
        };
    }])
    .directive('draggableCure', function() {
        return {
            restrict: 'A',
            link: function(scope, element, attrs) {
                var cureView = scope[attrs["draggableCure"]];
                $(element).draggable({
                        distance: 5,
                        opacity: 0.5,
                        revert: "invalid",
                        zIndex:10,
                        cursorAt: { top:-5,left:-5 },
                        start: function(){
                            if (!cureView || !cureView.getModel())
                                return false;
                            // On drag set that flag to not null
                            scope.dd.view.selected.categoryView.draggedCureView = cureView;

                        },
                        stop:function () {

                            scope.dd.view.selected.categoryView.draggedCureView = null;
                        }
                    }
                );

            }
        };
    })
    .directive('draggableLoyaltyCard', function() {
        return {
            restrict: 'A',
            link: function(scope, element, attrs) {
                var loyaltyCardView = scope[attrs["draggableLoyaltyCard"]];
                $(element).draggable({
                        distance: 5,
                        opacity: 0.5,
                        revert: "invalid",
                        zIndex:10,
                        cursorAt: { top:-5,left:-5 },
                        start: function(){
                            if (!loyaltyCardView || !loyaltyCardView.getModel())
                                return false;
                            // On drag set that flag to not null
                            scope.dd.view.selected.categoryView.draggedLoyaltyCardView = loyaltyCardView;

                        },
                        stop:function () {

                            scope.dd.view.selected.categoryView.draggedLoyaltyCardView = null;
                        }
                    }
                );

            }
        };
    })
    .directive('clickCategory',["$timeout", function($timeout) { //used to stop action during drag
        return {
            restrict: 'A',
            link: function(scope, element, attrs) {
                let categoryView = scope[attrs["clickCategory"]];

               element.bind('click', function(event)
                {
                    // On mobile platform, the category editing screen is displayed in front after a click, so it is impossible to handle the double click
                    if(scope.ad.isMobileOrPadTouchScreen){
                        if (categoryView.dblClickTimeout){
                            //on double click
                            $timeout.cancel(categoryView.dblClickTimeout);
                            if(scope.dd.view.selected.categoryView && scope.dd.view.selected.categoryView.draggedCategoryView == null){
                                scope.setCurrentCategory(categoryView);
                                categoryView.dblClickTimeout = null;
                                scope.$apply();
                            }
                        }
                        else{
                            categoryView.dblClickTimeout = $timeout(function() {
                                if(scope.dd.view.selected.categoryView && scope.dd.view.selected.categoryView.draggedCategoryView == null){
                                    if (scope.dd.view.edited.categoryView!==categoryView){
                                        scope.setEditedCategory(categoryView);
                                        categoryView.dblClickTimeout = null;
                                        scope.$apply();
                                    }
                                }

                            },350);
                        }
                    }
                    else{
                        if(scope.dd.view.selected.categoryView && scope.dd.view.selected.categoryView.draggedCategoryView == null){
                            if (scope.dd.view.edited.categoryView===categoryView)
                                scope.setCurrentCategory(categoryView)//on double click
                            else
                                scope.setEditedCategory(categoryView)
                        }
                        scope.$apply();
                    }
                });
            }
        };
    }])
    .directive('clickService', function() { //used to stop action during drag
        return {
            restrict: 'A',
            link: function(scope, element, attrs) {
                var serviceView = scope[attrs["clickService"]];
                element.bind('click', function(event)
                {
                    if(scope.dd.view.selected.categoryView && scope.dd.view.selected.categoryView.draggedServiceView == null){
                        scope.serviceClicked(serviceView);
                        scope.$apply();
                    }
                });

            }
        };
    })
    .directive('clickProduct', function() { //used to stop action during drag
        return {
            restrict: 'A',
            link: function(scope, element, attrs) {
                var productView = scope[attrs["clickProduct"]];
                element.bind('click', function(event)
                {
                    if(scope.dd.view.selected.categoryView && scope.dd.view.selected.categoryView.draggedProductView == null){
                        scope.productClicked(productView);
                        scope.$apply();
                    }
                });

            }
        };
    })
    .directive('clickCure', function() { //used to stop action during drag
        return {
            restrict: 'A',
            link: function(scope, element, attrs) {
                var cureView = scope[attrs["clickCure"]];
                element.bind('click', function(event)
                {
                    if(scope.dd.view.selected.categoryView && scope.dd.view.selected.categoryView.draggedCureView == null){
                        scope.cureClicked(cureView);
                        scope.$apply();
                    }
                });

            }
        };
    })
    .directive('clickLoyaltyCard', function() { //used to stop action during drag
        return {
            restrict: 'A',
            link: function(scope, element, attrs) {
                var loyaltyCardView = scope[attrs["clickLoyaltyCard"]];
                element.bind('click', function(event)
                {
                    if(scope.dd.view.selected.categoryView && scope.dd.view.selected.categoryView.draggedLoyaltyCardView == null){
                        scope.loyaltyCardClicked(loyaltyCardView);
                        scope.$apply();
                    }
                });

            }
        };
    })
    .directive('droppableCategory', ["CategorySrv", function(CategorySrv) {
        return {
            restrict: 'A',
            link: function(scope, element, attrs) {
                var categoryView = scope[attrs["droppableCategory"]];
                $(element).droppable({
                    activeClass: 'active',
                    hoverClass:'hovered',
                    tolerance:'pointer',
                    drop:function(event,ui){
                        if (scope.dd.view.selected.categoryView.draggedServiceView)
                        {
                            categoryView.moveService(scope.dd.view.selected.categoryView.draggedServiceView);
                            scope.dd.view.selected.categoryView.draggedServiceView==null;
                        }
                        else
                            if (scope.dd.view.selected.categoryView.draggedCategoryView)
                            {
                                categoryView.moveCategory(scope.dd.view.selected.categoryView.draggedCategoryView);
                                scope.dd.view.selected.categoryView.draggedCategoryView = null;
                            }
                        $("button.selector-btn-edit-image").show();
                        scope.$apply();

                    }
                });
             }
        };
    }])
    .directive('droppableUpCategory', ["CategorySrv", function(CategorySrv) {
        return {
            restrict: 'A',
            link: function(scope, element, attrs) {
                $(element).droppable({
                    activeClass: 'active',
                    hoverClass:'hovered',
                    tolerance:'pointer',
                    drop:function(event,ui){
                        if (scope.dd.view.selected.categoryView.draggedServiceView)
                        {
                            scope.dd.view.selected.categoryView.parentCategoryView.moveService(scope.dd.view.selected.categoryView.draggedServiceView);
                            scope.dd.view.selected.categoryView.draggedServiceView = null;
                        }
                        else
                            if (scope.dd.view.selected.categoryView.draggedCategoryView)
                            {
                                scope.dd.view.selected.categoryView.parentCategoryView.moveCategory(scope.dd.view.selected.categoryView.draggedCategoryView);
                                scope.dd.view.selected.categoryView.draggedCategoryView = null;
                            }
                            $("button.selector-btn-edit-image").show();
                            scope.$apply();
                    }
                });
            }
        };
    }])
    .directive('droppableProductCategory', ["CategorySrv", function(CategorySrv) {
        return {
            restrict: 'A',
            link: function(scope, element, attrs) {
                var categoryView = scope[attrs["droppableProductCategory"]];
                $(element).droppable({
                    activeClass: 'active',
                    hoverClass:'hovered',
                    tolerance:'pointer',
                    drop:function(event,ui){
                        if (scope.dd.view.selected.categoryView.draggedProductView)
                        {
                            categoryView.moveProduct(scope.dd.view.selected.categoryView.draggedProductView);
                            scope.dd.view.selected.categoryView.draggedProductView==null;
                        }
                        else
                        if (scope.dd.view.selected.categoryView.draggedCategoryView)
                        {
                            categoryView.moveCategory(scope.dd.view.selected.categoryView.draggedCategoryView);
                            scope.dd.view.selected.categoryView.draggedCategoryView = null;
                        }
                        $("button.selector-btn-edit-image").show();
                        scope.$apply();

                    }
                });
            }
        };
    }])
    .directive('droppableUpProductCategory', ["CategorySrv", function(CategorySrv) {
        return {
            restrict: 'A',
            link: function(scope, element, attrs) {
                $(element).droppable({
                    activeClass: 'active',
                    hoverClass:'hovered',
                    tolerance:'pointer',
                    drop:function(event,ui){
                        if (scope.dd.view.selected.categoryView.draggedProductView)
                        {
                            scope.dd.view.selected.categoryView.parentCategoryView.moveProduct(scope.dd.view.selected.categoryView.draggedProductView);
                            scope.dd.view.selected.categoryView.draggedProductView==null;
                        }
                        else
                        if (scope.dd.view.selected.categoryView.draggedCategoryView)
                        {
                            scope.dd.view.selected.categoryView.parentCategoryView.moveCategory(scope.dd.view.selected.categoryView.draggedCategoryView);
                            scope.dd.view.selected.categoryView.draggedCategoryView = null;
                        }
                        $("button.selector-btn-edit-image").show();
                        scope.$apply();

                    }
                });
            }
        };
    }])
    .directive('droppableCureCategory', ["CategorySrv", function(CategorySrv) {
        return {
            restrict: 'A',
            link: function(scope, element, attrs) {
                var categoryView = scope[attrs["droppableCureCategory"]];
                $(element).droppable({
                    activeClass: 'active',
                    hoverClass:'hovered',
                    tolerance:'pointer',
                    drop:function(event,ui){
                        if (scope.dd.view.selected.categoryView.draggedCureView)
                        {
                            categoryView.moveCure(scope.dd.view.selected.categoryView.draggedCureView);
                            scope.dd.view.selected.categoryView.draggedCureView==null;
                        }
                        else
                        if (scope.dd.view.selected.categoryView.draggedCategoryView)
                        {
                            categoryView.moveCategory(scope.dd.view.selected.categoryView.draggedCategoryView);
                            scope.dd.view.selected.categoryView.draggedCategoryView = null;
                        }
                        $("button.selector-btn-edit-image").show();
                        scope.$apply();

                    }
                });
            }
        };
    }])
    .directive('droppableUpCureCategory', ["CategorySrv", function(CategorySrv) {
        return {
            restrict: 'A',
            link: function(scope, element, attrs) {
                $(element).droppable({
                    activeClass: 'active',
                    hoverClass:'hovered',
                    tolerance:'pointer',
                    drop:function(event,ui){
                        if (scope.dd.view.selected.categoryView.draggedCureView)
                        {
                            scope.dd.view.selected.categoryView.parentCategoryView.moveCure(scope.dd.view.selected.categoryView.draggedCureView);
                            scope.dd.view.selected.categoryView.draggedCureView==null;
                        }
                        else
                        if (scope.dd.view.selected.categoryView.draggedCategoryView)
                        {
                            scope.dd.view.selected.categoryView.parentCategoryView.moveCategory(scope.dd.view.selected.categoryView.draggedCategoryView);
                            scope.dd.view.selected.categoryView.draggedCategoryView = null;
                        }
                        $("button.selector-btn-edit-image").show();
                        scope.$apply();

                    }
                });
            }
        };
    }])
    .directive('droppableLoyaltyCardCategory', ["CategorySrv", function(CategorySrv) {
        return {
            restrict: 'A',
            link: function(scope, element, attrs) {
                var categoryView = scope[attrs["droppableLoyaltyCardCategory"]];
                $(element).droppable({
                    activeClass: 'active',
                    hoverClass:'hovered',
                    tolerance:'pointer',
                    drop:function(event,ui){
                        if (scope.dd.view.selected.categoryView.draggedLoyaltyCardView)
                        {
                            categoryView.moveLoyaltyCard(scope.dd.view.selected.categoryView.draggedLoyaltyCardView);
                            scope.dd.view.selected.categoryView.draggedLoyaltyCardView==null;
                        }
                        else
                        if (scope.dd.view.selected.categoryView.draggedCategoryView)
                        {
                            categoryView.moveCategory(scope.dd.view.selected.categoryView.draggedCategoryView);
                            scope.dd.view.selected.categoryView.draggedCategoryView = null;
                        }
                        $("button.selector-btn-edit-image").show();
                        scope.$apply();

                    }
                });
            }
        };
    }])
    .directive('droppableUpLoyaltyCardCategory', ["CategorySrv", function(CategorySrv) {
        return {
            restrict: 'A',
            link: function(scope, element, attrs) {
                $(element).droppable({
                    activeClass: 'active',
                    hoverClass:'hovered',
                    tolerance:'pointer',
                    drop:function(event,ui){
                        if (scope.dd.view.selected.categoryView.draggedLoyaltyCardView)
                        {
                            scope.dd.view.selected.categoryView.parentCategoryView.moveLoyaltyCard(scope.dd.view.selected.categoryView.draggedLoyaltyCardView);
                            scope.dd.view.selected.categoryView.draggedLoyaltyCardView==null;
                        }
                        else
                        if (scope.dd.view.selected.categoryView.draggedCategoryView)
                        {
                            scope.dd.view.selected.categoryView.parentCategoryView.moveCategory(scope.dd.view.selected.categoryView.draggedCategoryView);
                            scope.dd.view.selected.categoryView.draggedCategoryView = null;
                        }
                        $("button.selector-btn-edit-image").show();
                        scope.$apply();

                    }
                });
            }
        };
    }])
    .directive('droppableCategoryMoveLeft', function() {
        return {
            restrict: 'A',
            link: function(scope, element, attrs) {
                var categoryView = scope[attrs["droppableCategoryMoveLeft"]];
                $(element).droppable({
                    activeClass: 'active',
                    hoverClass:'hovered',
                    tolerance:'pointer',
                    accept: ".category",
                    drop:function(event,ui){
                            if (scope.dd.view.selected.categoryView.draggedCategoryView){
                                scope.dd.view.selected.categoryView.changeCategoryPosition(scope,scope.dd.view.selected.categoryView.draggedCategoryView,scope.dd.view.selected.categoryView.categoriesView.indexOf(categoryView));
                                scope.dd.view.selected.categoryView.draggedCategoryView = null;
                                $("button.selector-btn-edit-image").show();
                            }


                    }
                });
            }
        };
    })
    .directive('droppableCategoryMoveRight', function() {
        return {
            restrict: 'A',
            link: function(scope, element, attrs) {
                var categoryView = scope[attrs["droppableCategoryMoveRight"]];
                $(element).droppable({
                    activeClass: 'active',
                    hoverClass:'hovered',
                    tolerance:'pointer',
                    accept: ".category",
                    drop:function(event,ui){

                        if (scope.dd.view.selected.categoryView.draggedCategoryView){
                            scope.dd.view.selected.categoryView.changeCategoryPosition(scope,scope.dd.view.selected.categoryView.draggedCategoryView,scope.dd.view.selected.categoryView.categoriesView.indexOf(categoryView)+1);
                            scope.dd.view.selected.categoryView.draggedCategoryView = null;
                            $("button.selector-btn-edit-image").show();
                        }

                    }
                });
            }
        };
    })
    .directive('droppableServiceMoveLeft', function() {
        return {
            restrict: 'A',
            link: function(scope, element, attrs) {
                var serviceView = scope[attrs["droppableServiceMoveLeft"]];
                if (scope.dd.view.selected.categoryView.servicesView.indexOf(serviceView)==0)//accept to drop also category for the first service
                    $(element).droppable({
                        activeClass: 'active',
                        hoverClass:'hovered',
                        tolerance:'pointer',
                        drop:function(event,ui){
                            if (scope.dd.view.selected.categoryView.draggedServiceView){
                                scope.dd.view.selected.categoryView.changeServicePosition(scope,scope.dd.view.selected.categoryView.draggedServiceView,scope.dd.view.selected.categoryView.servicesView.indexOf(serviceView));
                                scope.dd.view.selected.categoryView.draggedServiceView = null;
                                $("button.selector-btn-edit-image").show();
                            }
                            if (scope.dd.view.selected.categoryView.draggedCategoryView){
                                scope.dd.view.selected.categoryView.changeCategoryPosition(scope,scope.dd.view.selected.categoryView.draggedCategoryView,scope.dd.view.selected.categoryView.categoriesView.length);//put at the end
                                scope.dd.view.selected.categoryView.draggedCategoryView = null;
                                $("button.selector-btn-edit-image").show();
                            }

                        }
                    });
                else
                    $(element).droppable({
                        activeClass: 'active',
                        hoverClass:'hovered',
                        tolerance:'pointer',
                        accept: ".service",
                        drop:function(event,ui){
                            if (scope.dd.view.selected.categoryView.draggedServiceView){
                                scope.dd.view.selected.categoryView.changeServicePosition(scope,scope.dd.view.selected.categoryView.draggedServiceView,scope.dd.view.selected.categoryView.servicesView.indexOf(serviceView));
                                scope.dd.view.selected.categoryView.draggedServiceView = null;
                                $("button.selector-btn-edit-image").show();
                            }

                        }
                    });

            }
        };
    })
    .directive('droppableServiceMoveRight', function() {
        return {
            restrict: 'A',
            link: function(scope, element, attrs) {
                var serviceView = scope[attrs["droppableServiceMoveRight"]];
                $(element).droppable({
                    activeClass: 'active',
                    hoverClass:'hovered',
                    tolerance:'pointer',
                    accept: ".service",
                    drop:function(event,ui){
                        if (scope.dd.view.selected.categoryView.draggedServiceView){
                            scope.dd.view.selected.categoryView.changeServicePosition(scope,scope.dd.view.selected.categoryView.draggedServiceView,scope.dd.view.selected.categoryView.servicesView.indexOf(serviceView)+1);
                            scope.dd.view.selected.categoryView.draggedServiceView = null;
                            $("button.selector-btn-edit-image").show();
                        }

                    }
                });
            }
        };
    })
    .directive('droppableProductMoveLeft',["$timeout", function($timeout) {
        return {
            restrict: 'A',
            link: function(scope, element, attrs) {
                var productView = scope[attrs["droppableProductMoveLeft"]];
                $timeout(function(){
                if (scope.dd.view.selected.categoryView.productsView.indexOf(productView)==0)//accept to drop also category for the first productView
                    $(element).droppable({
                        activeClass: 'active',
                        hoverClass:'hovered',
                        tolerance:'pointer',
                        drop:function(event,ui){
                            if (scope.dd.view.selected.categoryView.draggedProductView){
                                scope.dd.view.selected.categoryView.changeProductPosition(scope,scope.dd.view.selected.categoryView.draggedProductView,scope.dd.view.selected.categoryView.productsView.indexOf(productView));
                                scope.dd.view.selected.categoryView.draggedProductView = null;
                                $("button.selector-btn-edit-image").show();
                            }
                            if (scope.dd.view.selected.categoryView.draggedCategoryView){
                                scope.dd.view.selected.categoryView.changeCategoryPosition(scope,scope.dd.view.selected.categoryView.draggedCategoryView,scope.dd.view.selected.categoryView.categoriesView.length);//put at the end
                                scope.dd.view.selected.categoryView.draggedCategoryView = null;
                                $("button.selector-btn-edit-image").show();
                            }

                        }
                    });
                else
                    $(element).droppable({
                        activeClass: 'active',
                        hoverClass:'hovered',
                        tolerance:'pointer',
                        accept: ".service",
                        drop:function(event,ui){
                            if (scope.dd.view.selected.categoryView.draggedProductView){
                                scope.dd.view.selected.categoryView.changeProductPosition(scope,scope.dd.view.selected.categoryView.draggedProductView,scope.dd.view.selected.categoryView.productsView.indexOf(productView));
                                scope.dd.view.selected.categoryView.draggedProductView = null;
                                $("button.selector-btn-edit-image").show();
                            }

                        }
                    });
                },500);
            }
        };
    }])
    .directive('droppableProductMoveRight',  ["$timeout", function($timeout) {
        return {
            restrict: 'A',
            link: function(scope, element, attrs) {
                var productView = scope[attrs["droppableProductMoveRight"]];
                $timeout(function(){
                    $(element).droppable({
                        activeClass: 'active',
                        hoverClass:'hovered',
                        tolerance:'pointer',
                        accept: ".service",
                        drop:function(event,ui){
                            if (scope.dd.view.selected.categoryView.draggedProductView){
                                scope.dd.view.selected.categoryView.changeProductPosition(scope,scope.dd.view.selected.categoryView.draggedProductView,scope.dd.view.selected.categoryView.productsView.indexOf(productView)+1);
                                scope.dd.view.selected.categoryView.draggedProductView = null;
                                $("button.selector-btn-edit-image").show();
                            }

                        }
                    });
                },500);
            }
        };
    }])
    .directive('droppableCureMoveLeft', function() {
        return {
            restrict: 'A',
            link: function(scope, element, attrs) {
                var cureView = scope[attrs["droppableCureMoveLeft"]];
                if (scope.dd.view.selected.categoryView.curesView.indexOf(cureView)==0)//accept to drop also category for the first cureView
                    $(element).droppable({
                        activeClass: 'active',
                        hoverClass:'hovered',
                        tolerance:'pointer',
                        drop:function(event,ui){
                            if (scope.dd.view.selected.categoryView.draggedCureView){
                                scope.dd.view.selected.categoryView.changeCurePosition(scope,scope.dd.view.selected.categoryView.draggedCureView,scope.dd.view.selected.categoryView.curesView.indexOf(cureView));
                                scope.dd.view.selected.categoryView.draggedCureView = null;
                                $("button.selector-btn-edit-image").show();
                            }
                            if (scope.dd.view.selected.categoryView.draggedCategoryView){
                                scope.dd.view.selected.categoryView.changeCategoryPosition(scope,scope.dd.view.selected.categoryView.draggedCategoryView,scope.dd.view.selected.categoryView.categoriesView.length);//put at the end
                                scope.dd.view.selected.categoryView.draggedCategoryView = null;
                                $("button.selector-btn-edit-image").show();
                            }

                        }
                    });
                else
                    $(element).droppable({
                        activeClass: 'active',
                        hoverClass:'hovered',
                        tolerance:'pointer',
                        accept: ".service",
                        drop:function(event,ui){
                            if (scope.dd.view.selected.categoryView.draggedCureView){
                                scope.dd.view.selected.categoryView.changeCurePosition(scope,scope.dd.view.selected.categoryView.draggedCureView,scope.dd.view.selected.categoryView.curesView.indexOf(cureView));
                                scope.dd.view.selected.categoryView.draggedCureView = null;
                                $("button.selector-btn-edit-image").show();
                            }

                        }
                    });

            }
        };
    })
    .directive('droppableCureMoveRight', function() {
        return {
            restrict: 'A',
            link: function(scope, element, attrs) {
                var cureView = scope[attrs["droppableCureMoveRight"]];
                $(element).droppable({
                    activeClass: 'active',
                    hoverClass:'hovered',
                    tolerance:'pointer',
                    accept: ".service",
                    drop:function(event,ui){
                        if (scope.dd.view.selected.categoryView.draggedCureView){
                            scope.dd.view.selected.categoryView.changeCurePosition(scope,scope.dd.view.selected.categoryView.draggedCureView,scope.dd.view.selected.categoryView.curesView.indexOf(cureView)+1);
                            scope.dd.view.selected.categoryView.draggedCureView = null;
                            $("button.selector-btn-edit-image").show();
                        }

                    }
                });
            }
        };
    })
    .directive('droppableLoyaltyCardMoveLeft', function() {
        return {
            restrict: 'A',
            link: function(scope, element, attrs) {
                var loyaltyCardView = scope[attrs["droppableLoyaltyCardMoveLeft"]];
                if (scope.dd.view.selected.categoryView.loyaltyCardsView.indexOf(loyaltyCardView)==0)//accept to drop also category for the first loyaltyCardView
                    $(element).droppable({
                        activeClass: 'active',
                        hoverClass:'hovered',
                        tolerance:'pointer',
                        drop:function(event,ui){
                            if (scope.dd.view.selected.categoryView.draggedLoyaltyCardView){
                                scope.dd.view.selected.categoryView.changeLoyaltyCardPosition(scope,scope.dd.view.selected.categoryView.draggedLoyaltyCardView,scope.dd.view.selected.categoryView.loyaltyCardsView.indexOf(loyaltyCardView));
                                scope.dd.view.selected.categoryView.draggedLoyaltyCardView = null;
                                $("button.selector-btn-edit-image").show();
                            }
                            if (scope.dd.view.selected.categoryView.draggedCategoryView){
                                scope.dd.view.selected.categoryView.changeCategoryPosition(scope,scope.dd.view.selected.categoryView.draggedCategoryView,scope.dd.view.selected.categoryView.categoriesView.length);//put at the end
                                scope.dd.view.selected.categoryView.draggedCategoryView = null;
                                $("button.selector-btn-edit-image").show();
                            }

                        }
                    });
                else
                    $(element).droppable({
                        activeClass: 'active',
                        hoverClass:'hovered',
                        tolerance:'pointer',
                        accept: ".service",
                        drop:function(event,ui){
                            if (scope.dd.view.selected.categoryView.draggedLoyaltyCardView){
                                scope.dd.view.selected.categoryView.changeLoyaltyCardPosition(scope,scope.dd.view.selected.categoryView.draggedLoyaltyCardView,scope.dd.view.selected.categoryView.loyaltyCardsView.indexOf(loyaltyCardView));
                                scope.dd.view.selected.categoryView.draggedLoyaltyCardView = null;
                                $("button.selector-btn-edit-image").show();
                            }

                        }
                    });

            }
        };
    })
    .directive('droppableLoyaltyCardMoveRight', function() {
        return {
            restrict: 'A',
            link: function(scope, element, attrs) {
                var loyaltyCardView = scope[attrs["droppableLoyaltyCardMoveRight"]];
                $(element).droppable({
                    activeClass: 'active',
                    hoverClass:'hovered',
                    tolerance:'pointer',
                    accept: ".service",
                    drop:function(event,ui){
                        if (scope.dd.view.selected.categoryView.draggedLoyaltyCardView){
                            scope.dd.view.selected.categoryView.changeLoyaltyCardPosition(scope,scope.dd.view.selected.categoryView.draggedLoyaltyCardView,scope.dd.view.selected.categoryView.loyaltyCardsView.indexOf(loyaltyCardView)+1);
                            scope.dd.view.selected.categoryView.draggedLoyaltyCardView = null;
                            $("button.selector-btn-edit-image").show();
                        }

                    }
                });

            }
        };
    })
    .directive('resizable', ["$timeout", "BookingServiceView", "BookingSaveTransactionOrigin", function($timeout,BookingServiceView,BookingSaveTransactionOrigin) {
        return {
            restrict: 'A',
            link: function(scope, element, attrs) {
                var activityView = scope[attrs["resizable"]];
                var jqActTooltip = $("#activity-tooltip");
                var jqActTooltipHour = $("#activity-tooltip-hour");
                var jqActTooltipDay = $("#activity-tooltip-day");
                var jqActTooltipHr = $("#activity-tooltip-hr");
                var startPeriodStart = "";
                var startPeriodEnd = "";
                var jqElm = $(element);
                if (scope.dd.view.pTView && !scope.dd.view.pTView.dim.mobileFormat && !scope.ad.isMobileOrPadTouchScreen)//inactive on mobile
                $(element).resizable({
                    handles: 's',
                    containment: 'parent',
                    start : function(){
                        if(scope.isReadOnly())  {
                            return false;
                        }
                        scope.dd.view.pTView.resizeOrDrag.activityView = activityView;
                        if (activityView.period)
                        {
                            startPeriodStart = activityView.period.start.getLabel();
                            startPeriodEnd = activityView.period.end.getLabel();
                        }
                        jqActTooltipDay.html(activityView.plgDayHrView.plgDayView.labelDayOfWC);
                        jqActTooltipHr.html(activityView.plgDayHrView.hrView.label);
                    },
                    resize: function() {
                        activityView.resize($(element).height())
                        var cPeriodStart = activityView.period.start.getLabel();
                        var cPeriodEnd = activityView.period.end.getLabel();
                        jqActTooltipHour.html(cPeriodStart + " - " + cPeriodEnd);
                        if (startPeriodStart!=cPeriodStart || startPeriodEnd!=cPeriodEnd)
                            jqActTooltipHour.addClass("modified");
                        else
                            jqActTooltipHour.removeClass("modified");

                    },
                    stop:function ( event, ui ) {
                        jqActTooltipHour.removeClass("modified");
                        if (activityView instanceof BookingServiceView)
                        {
                            if (!scope.dd.view.pTView.getEditedBookingView())  //if not edited
                                activityView.bookingView.updateModel(null, BookingSaveTransactionOrigin.DIRECTIVES_PRO); //save all booking
                        }
                        else
                            activityView.updateModel();

                        scope.dd.view.pTView.resizeOrDrag.activityView = null;
                        scope.$apply();
                        $timeout (function () {

                            jqElm.animate({ 'top': (activityView.position.top+'px'),'left': (activityView.position.leftPercent)});
                        },100);

                    }

                });

            }
        };
    }]).directive('fxbActivity', function() {
        return {
            restrict: 'A',
            link: function($scope, element, attrs) {
                if ($scope.dd.view.pTView)
                {
                    var aDayRView = $scope[attrs["fxbActivity"]];
                    // var jqAct = $(element);
                    $scope.dd.view.pTView.addActivityForJQ(aDayRView, element);
                }
            }
        };
    }).directive('droppable', ["CategorySrv", function(CategorySrv) {
        return {
            restrict: 'A',
            link: function(scope, element, attrs) {
                var cell = scope[attrs["droppable"]];
                $(element).droppable({
                    activeClass: 'active',
                    hoverClass:'hovered',
                    tolerance:'pointer',
                    drop:function(event,ui){
                        if (scope.dd.view.pTView.edited) {
                            scope.$apply();
                        }
                    }
                });
            }
        };
    }])
    .directive('fxbCellTooltip', function() {
        return {
            restrict: 'A',
            link: function($scope, element, attrs) {
                if ($scope.dd.view.pTView) {
                    var cell = $scope[attrs["fxbCellTooltip"]];
                    // var jqAct = $(element);
                    $scope.dd.view.pTView.addCellForJQ(cell, element);
                }
            }
        };
    })
    .directive('handsometableCustomers', function() {
        return {
            restrict: 'A',
            link: function(scope, element, attrs) {
                //noinspection JSUnresolvedFunction
                var data = scope.dd.view.customersExportView;
                $(element).handsontable({
                    data: data,
                    colHeaders: ["Nom", "Prénom", "Téléphone", "Email"],
                    rowHeaders: true,
                    startRows: 10,
                    manualColumnResize: true,
                    minSpareRows: 1
                });
            }
        };
    })
    .directive('handsometableBookings', function() {
        return {
            restrict: 'A',
            link: function(scope, element, attrs) {
                //noinspection JSUnresolvedFunction
                var data = scope.dd.view.bookingsExportView;
                $(element).handsontable({
                    data: data,
                    colHeaders: ["Date et heure de début", "Date et heure de fin", "Commentaires", "Venu / pas venu","Crée le","Crée par","Pris par internet","Agenda","Rdv proposé","Abréviation","Prix","Nom","Prénom","Date de naissance","E-mail","Tél. portable"],
                    rowHeaders: true,
                    startRows: 10,
                    manualColumnResize: true,
                    minSpareRows: 1
                });
            }
        };
    })
    .directive("filereadCsv", ["$timeout",function ($timeout) {
        return {
            scope: {
                filereadCsv: "=",
                filereadCsvLoading : '=',
                filereadCsvEndFunction : '='
            },
            link: function (scope, element, attributes) {
                element.bind("change", function (changeEvent) {
                    var reader = new FileReader();
                    scope.$apply(function () {
                        scope.filereadCsvLoading = true;
                    });

                    reader.onload = function (loadEvent) {
                        $timeout(function() {
                        scope.$apply(function () {
                            var csv = loadEvent.target.result;
                            csv = csv.replace(/(\r\n|\n|\r)/gm,'\n');
                            var allTextLines = csv.split('\n');
                            scope.filereadCsv = [];
                            for (var i=0; i<allTextLines.length; i++) {
                                var data = allTextLines[i].split(';');
                                var tarr = [];
                                for (var j=0; j<data.length; j++) {
                                    tarr.push(data[j]);
                                }
                                scope.filereadCsv.push(tarr);
                            }
                            if (scope.filereadCsvEndFunction!==undefined)
                                scope.filereadCsvEndFunction(scope.filereadCsv);
                            scope.filereadCsvLoading = false;
                        });
                        },200);
                    }
                    $timeout(function() {
                            reader.readAsText(changeEvent.target.files[0]);
                        },200);

                });
            }
        }
    }])
    .directive("filereadXls", ["$timeout",function ($timeout) {
        return {
            scope: {
                filereadXls: "=",
                filereadXlsLoading : '=',
                filereadXlsEndFunction : '='
            },
            link: function (scope, element, attributes) {
                element.bind("change", function (changeEvent) {
                    var reader = new FileReader();
                    scope.$apply(function () {
                        scope.filereadXlsLoading = true;
                    });

                    reader.onload = function (loadEvent) {
                        scope.$apply(function () {
                            var data = loadEvent.target.result;
                            var workbook = XLS.read(data, {type: 'binary'});
                            var result = {};
                            var i =0;
                            workbook.SheetNames.forEach(function(sheetName) {
                                var roa = XLS.utils.sheet_to_row_object_array(workbook.Sheets[sheetName]);
                                if(roa.length > 0){
                                    result[i++] = roa;
                                }
                            });
                            scope.filereadXls = result[0];

                            if (scope.filereadXlsEndFunction!==undefined)
                                scope.filereadXlsEndFunction(scope.filereadXls);
                            scope.filereadXlsLoading = false;
                        });
                    };
                    $timeout(function() {
                        reader.readAsBinaryString(changeEvent.target.files[0]);
                    },200);

                });
            }
        }
    }])
    .directive('fxbMessage', function() {
        var directive = { restrict: 'E', replace: true };
        directive.template =
            '<div class="fxb-message" ng-show="message"  ng-class="message.type">' +
                '<div class="message-content">'+
                    '<div>' +
                        '<span ng-show="message" ng-bind-html="messageHtml"/></span>' +
                        '&nbsp;<button ng-show="message.type!=\'info\' && message.type!=\'alert\'" class="btn btn-ultra-mini" ng-click="reloadApplication()" translate>Recharger</button>' +
                        '<button ng-show="message.type==\'info\'" class="btn btn-ultra-mini" ng-click="message=null" translate>Fermer</button>' +
                    '</div>'+
                    '<button class="message-close btn btn-ultra-mini" ng-click="message=null"><i class="fa fa-times"></i></button>' +
                '</div>'+
            '</div>';
        var ctrl = function ($scope,$log,$rootScope,$sce) {
            $rootScope.$on('fxbMessage', function (_, message, isNotFromAngularEvent) {
                $scope.message = message;
                if (message)
                    $scope.messageHtml = $sce.trustAsHtml(message.text);
                if (isNotFromAngularEvent !== undefined && isNotFromAngularEvent && $scope.safeApply!== undefined)
                    $scope.safeApply();
            });
        };
        directive.controller = ('DirCtrl', ['$scope','$log','$rootScope','$sce', ctrl]);

        return directive;
    })

    .directive('editableField', function () {
        return {
            restrict: 'A',
            scope: {
                editableField:'=',
            },
            template:
             '<input type="text" ng-show="(objectMouse.hasMouseover || objectMouse.hasFocus)" ng-model="editableField" ng-focus="objectMouse.hasFocus=true" ng-blur="objectMouse.hasFocus=false" ng-mouseleave="objectMouse.hasMouseover=false"/>'+
             '<span ng-show="!(objectMouse.hasMouseover || objectMouse.hasFocus)" ng-bind="editableField" ng-mouseover="objectMouse.hasMouseover=true"></span>',
            controller: ['$scope', function($scope) {
                $scope.objectMouse = {
                    hasMouseover : false,
                    hasFocus : false,

                }
            }]
        }
    })
    .directive('taxParameters', function() {
        return {
            restrict: 'E',
            scope: {
                taxMode: '=taxMode',
                shortLabel:'=shortLabel',
                onTaxModeChange : '&onTaxModeChange'
            },
            templateUrl: '/partials/planningPos/pos/posTaxMode.html',
            controller: ['$scope', 'TaxMode',
                function ($scope, TaxMode) {
                    $scope.TaxModeList = TaxMode;

                    $scope.onTaxModeClick = function(newTaxMode){
                        $scope.onTaxModeChange({newTaxMode:newTaxMode});
                    }
                }]
        }
    })
    .directive('timeParameters', function() {
        return {
            restrict: 'E',
            scope: {
                timePeriod : '=timePeriod',
                beginMoment : '=beginMoment',
                endMoment : '=endMoment',
                forceReload : '=forceReload',
                onPeriodChanged : '&onPeriodChanged',
                hidePeriodType : "=hidePeriodType"
             },
            templateUrl: '/partials/statistics/timeParameters.html',
            link: function($scope, $elm, attrs, timeParameterCtrl) {
                $scope.$watch('forceReload', function () {
                   if($scope.forceReload) {
                       $scope.init();
                   }
                });
            },
            controller: ['$scope', '$timeout', 'Day', 'DayData', 'PeriodStat', 'StatPeriodType', 'PeriodType','moment',
                function($scope, $timeout, Day, DayData, PeriodStat, StatPeriodType, PeriodType, moment) {

                $scope.dd = {
                    timePeriod :$scope.timePeriod,
                    begin : null,
                    end : null,
                    currentPeriod : null,
                    pastPeriod : null,
                    goBackDisabled : null,
                    goNextDisabled : null,
                    firstDay : DayData.getActiveList()[0].getMomentDate(),
                };

                $scope.PeriodType = PeriodType;

                $scope.init = function() {
                    $scope.planningDailyDatePicker = {
                        opened: false,
                        minDate: $scope.dd.firstDay.toDate(),
                        date : new Date(),
                        dateOptions: {
                            'year-format': "'yy'",
                            'starting-day': 1,
                            'datepickerMode': 'day'
                        },
                        needToUpdateVarNow: false
                    };

                    $scope.planningDailyBeginDatePicker = {
                        opened: false,
                        minDate: $scope.dd.firstDay.toDate(),
                        date : new Date(),
                        dateOptions: {
                            'year-format': "'yy'",
                            'starting-day': 1,
                            'datepickerMode': 'day'
                        },
                        needToUpdateVarNow: false
                    };

                    $scope.planningDailyEndDatePicker = {
                        opened: false,
                        minDate: $scope.dd.firstDay.toDate(),
                        date : new Date(),
                        dateOptions: {
                            'year-format': "'yy'",
                            'starting-day': 1,
                            'datepickerMode': 'day'
                        },
                        needToUpdateVarNow: false
                    };

                    $scope.planningMonthlyDatePicker = {
                        opened: false,
                        minDate: $scope.dd.firstDay.toDate(),
                        date : new Date(),
                        dateOptions: {
                            'year-format': "'yy'",
                            'starting-day': 1,
                            'datepickerMode': 'month',
                            'minMode': 'month'
                        },
                        needToUpdateVarNow: false
                    };

                    $scope.planningYearlyDatePicker = {
                        opened: false,
                        minDate: $scope.dd.firstDay.toDate(),
                        date : new Date(),
                        dateOptions: {
                            'year-format': "'yy'",
                            'starting-day': 1,
                            'datepickerMode': 'year',
                            'minMode': 'year'
                        },
                        needToUpdateVarNow: false
                    };

                    if ($scope.dd.timePeriod === PeriodType.CUSTOMED) {
                        $scope.goToDate($scope.beginMoment, 'begin');
                        $scope.goToDate($scope.endMoment, 'end');
                    }
                    else{
                        $scope.goToDate($scope.beginMoment);
                    }

                }

                $scope.getSelectedDatePicker = function (type) {
                    var selectedDatePicker = null;

                    if ($scope.dd.timePeriod === PeriodType.DAY || $scope.dd.timePeriod ===PeriodType.WEEK) {
                        selectedDatePicker = $scope.planningDailyDatePicker;
                    }
                    if ($scope.dd.timePeriod === PeriodType.MONTH) {
                        selectedDatePicker = $scope.planningMonthlyDatePicker;
                    }
                    if ($scope.dd.timePeriod === PeriodType.YEAR) {
                        selectedDatePicker = $scope.planningYearlyDatePicker;
                    }
                    if ($scope.dd.timePeriod === PeriodType.CUSTOMED && type === 'begin') {
                        selectedDatePicker = $scope.planningDailyBeginDatePicker;
                    }
                    if ($scope.dd.timePeriod === PeriodType.CUSTOMED && type === 'end') {
                        selectedDatePicker = $scope.planningDailyEndDatePicker;
                    }

                    return selectedDatePicker;
                };

                $scope.displayPlanningDatePickerF = function (type) {
                    $timeout(function () {

                        var selectedDatePicker = $scope.getSelectedDatePicker(type);

                        // used to avoid the watcher to go to $scope.goToDate() (= modifiy scope.dd.now) on the click on the click to display datepicker
                        selectedDatePicker.needToUpdateVarNow = false;

                        if($scope.dd.timePeriod  === PeriodType.CUSTOMED || type === 'end') {
                            selectedDatePicker.date = $scope.dd.end.toDate();
                        }
                        else{
                            selectedDatePicker.date = $scope.dd.begin.toDate();
                        }
                        selectedDatePicker.opened = true;
                    });
                };

                $scope.$watch('planningDailyDatePicker.date', function (date) {
                    if (date &&  $scope.planningDailyDatePicker.needToUpdateVarNow) {
                        $scope.goToDate(new moment(date));
                    }
                    else
                        $scope.planningDailyDatePicker.needToUpdateVarNow = true;
                });

                $scope.$watch('planningMonthlyDatePicker.date', function (date) {
                    if (date && $scope.planningMonthlyDatePicker.needToUpdateVarNow) {
                        $scope.goToDate(new moment(date));
                    }
                    else
                        $scope.planningMonthlyDatePicker.needToUpdateVarNow = true;
                });

                $scope.$watch('planningYearlyDatePicker.date', function (date) {
                    if (date && $scope.planningYearlyDatePicker.needToUpdateVarNow) {
                        $scope.goToDate(new moment(date));
                    }
                    else
                        $scope.planningYearlyDatePicker.needToUpdateVarNow = true;
                });

                $scope.$watch('planningDailyBeginDatePicker.date', function (date) {
                    if (date && $scope.planningDailyBeginDatePicker.needToUpdateVarNow) {
                        $scope.goToDate(new moment(date), 'begin');
                    }
                    else
                        $scope.planningDailyBeginDatePicker.needToUpdateVarNow = true;
                });

                $scope.$watch('planningDailyEndDatePicker.date', function (date) {
                    if (date && $scope.planningDailyEndDatePicker.needToUpdateVarNow) {
                        $scope.goToDate(new moment(date), 'end');
                    }
                    else
                        $scope.planningDailyEndDatePicker.needToUpdateVarNow = true;
                });

                $scope.setLastYearCorrespondingPeriod = function() {
                    if($scope.dd.currentPeriod.getArrayOfDays() && $scope.dd.currentPeriod.getArrayOfDays().length>0) {
                        $scope.dd.pastPeriod = new PeriodStat(
                            StatPeriodType.PAST,
                            PeriodStat.getLastYearCorrespondingDay($scope.dd.currentPeriod.getArrayOfDays()[0].getMomentDate(), $scope.dd.currentPeriod.periodType),
                            PeriodType.getLastDayOfPeriod($scope.dd.currentPeriod.periodType, PeriodStat.getLastYearCorrespondingDay($scope.dd.currentPeriod.getArrayOfDays()[0].getMomentDate(), $scope.dd.currentPeriod.periodType), $scope.dd.currentPeriod.arrayOfDays.length),
                            $scope.dd.timePeriod
                        );
                    }
                };

                $scope.goToday = function () {
                    if ($scope.dd.timePeriod === PeriodType.CUSTOMED) {
                        $scope.goToDate(new moment().startOf('month'), 'begin');
                        $scope.goToDate(new moment().endOf('day'), 'end');
                    }
                    else{
                        $scope.goToDate(new moment());
                    }
                };

                $scope.goToDate = function (date, type) {
                    var now = new moment();

                    if ($scope.dd.timePeriod !== PeriodType.CUSTOMED){
                        $scope.dd.begin = date.clone();
                        $scope.dd.end = date.clone();

                        if ($scope.dd.timePeriod === PeriodType.DAY) {
                            $scope.dd.begin.startOf('day');
                            $scope.dd.end.startOf('day');

                            //$scope.dd.goNextDisabled = parseInt(new moment().format('YYYYMMDD')) <= parseInt($scope.dd.begin.format('YYYYMMDD'))

                        }
                        if ($scope.dd.timePeriod === PeriodType.WEEK) {
                            $scope.dd.begin.startOf('week');
                            $scope.dd.end.endOf('week');

                            //$scope.dd.goNextDisabled = parseInt(new moment().format('YYYYMMDD')) <= parseInt($scope.dd.begin.format('YYYYMMDD'))
                        }
                        if ($scope.dd.timePeriod === PeriodType.MONTH) {
                            $scope.dd.begin.startOf('month');
                            $scope.dd.end.endOf('month');

                            //$scope.dd.goNextDisabled = parseInt(new moment().format('YYYYMMDD')) <= parseInt($scope.dd.begin.format('YYYYMMDD'))
                        }
                        if ($scope.dd.timePeriod === PeriodType.YEAR) {
                            $scope.dd.begin.startOf('year');
                            $scope.dd.end.endOf('year');
                        }

                        /*if($scope.dd.end.isAfter(now)){
                            $scope.dd.end = now.endOf('day');
                        }*/
                    }
                    else{
                        if (type === 'begin') {
                            $scope.dd.begin = date.startOf('day');
                            if(!$scope.dd.end)
                                $scope.dd.end = date.endOf('day');
                        }
                        if (type === 'end') {
                            $scope.dd.end = date.endOf('day');
                        }
                    }

                    $scope.dd.goBackDisabled = parseInt($scope.dd.firstDay.format('YYYYMMDD')) >= parseInt($scope.dd.begin.format('YYYYMMDD'));
                    //$scope.dd.goNextDisabled = parseInt(new moment().format('YYYYMMDD')) >= parseInt($scope.dd.begin.format('YYYYMMDD')) && parseInt(new moment().format('YYYYMMDD')) <= parseInt($scope.dd.end.format('YYYYMMDD'));

                    $scope.dd.currentPeriod = new PeriodStat(StatPeriodType.CURRENT, $scope.dd.begin, $scope.dd.end, $scope.dd.timePeriod);

                    $scope.setLastYearCorrespondingPeriod();

                    $scope.onPeriodChanged({newCurrentPeriod : $scope.dd.currentPeriod, newPastPeriod : $scope.dd.pastPeriod});
                };

                $scope.goPrevious = function () {
                    if (!$scope.dd.goBackDisabled && $scope.dd.timePeriod !== PeriodType.CUSTOMED) {

                        var newBeginDate = $scope.dd.begin.clone();
                        if ($scope.dd.timePeriod === PeriodType.DAY) {
                            newBeginDate.subtract(1, 'days');
                        }
                        if ($scope.dd.timePeriod ===PeriodType.WEEK) {
                            newBeginDate.subtract(1,'weeks');
                            newBeginDate.startOf('week');
                        }
                        if ($scope.dd.timePeriod === PeriodType.MONTH) {
                            newBeginDate.subtract(1, 'months');
                            newBeginDate.startOf('month');
                        }
                        if ($scope.dd.timePeriod === PeriodType.YEAR) {
                            newBeginDate.subtract(1, 'years');
                            newBeginDate.startOf('year');
                        }

                        $scope.goToDate(newBeginDate);
                    }
                };

                $scope.goNext = function () {
                    if (!$scope.dd.goNextDisabled && $scope.dd.timePeriod !== PeriodType.CUSTOMED) {
                        var newBeginDate = $scope.dd.begin.clone();

                        if ($scope.dd.timePeriod === PeriodType.DAY) {
                            newBeginDate.add(1, 'days');
                        }
                        if ($scope.dd.timePeriod === PeriodType.WEEK) {
                            newBeginDate.add(1, 'weeks');
                            newBeginDate.startOf('week');
                        }
                        if ($scope.dd.timePeriod === PeriodType.MONTH) {
                            newBeginDate.add(1, 'months');
                            newBeginDate.startOf('month');
                        }
                        if ($scope.dd.timePeriod === PeriodType.YEAR) {
                            newBeginDate.add(1, 'years');
                            newBeginDate.startOf('year');
                        }

                        $scope.goToDate(newBeginDate);
                    }
                };
                $scope.init();
            }]
        }
    })
    .directive('flexyOldReport', function() {
        return {
            restrict: 'E',
            scope: {
                dashboardView:'=dashboardView',
                report:'=report',
                reportDataSource:'=reportDataSource'
            },
            template : '<div ng-include="getTemplateUrl()"></div>',
            controller: ['$scope', function($scope) {

                $scope.getTemplateUrl = function(){
                    return "/partials/statistics/report/oldReport/" + $scope.report.id + ".html"
                }
            }]
        }
    })
    .directive('flexyReportPath', function() {
        return {
            restrict: 'E',
            scope: {
                reportView:'=reportView'
            },
            templateUrl : '/partials/statistics/report/reportPath.html'
        }
    })
    .directive('customerReport', function() {
        return {
            restrict: 'E',
            scope: {
                customers:'=customers',
                showVisits:'=showVisits',
                nbPassageCustomers:'=nbPassageCustomers',
                primaryDatasType:'=primaryDatasType',
                isCommunicateView:'=isCommunicateView'
            },
            templateUrl : '/partials/statistics/report/reportPrimaryDataCustomerTemplate.html',
            controller: ['$scope','PrimaryDatasType', function($scope,PrimaryDatasType) {
                $scope.exportExcel = function(objet, idTable, title){
                    return ExcellentExport.excel(objet, idTable, title);
                }

                $scope.exportCsv = function(objet, idTable){
                    return ExcellentExport.csv(objet, idTable);
                }

                $scope.PrimaryDatasType = PrimaryDatasType;
            }]
        }
    })
    .directive('flexyReport',["TypeOfGraph", "ColorGraph", "EltReportType", "DateFormator", "PrimaryDatasType","$timeout", "PeriodStat","DayData","PeriodType","StatPeriodType","ReportTemporalAgregateFunctionType",
        "TaxMode","$filter","LanguageManager","CurrencyManager","ReportTotalAgregateFunctionType","BookingCreator","moment","Brand",

        function (TypeOfGraph, ColorGraph,EltReportType,DateFormator,PrimaryDatasType,$timeout,PeriodStat,DayData,PeriodType,StatPeriodType, ReportTemporalAgregateFunctionType,
                  TaxMode,$filter,LanguageManager,CurrencyManager,ReportTotalAgregateFunctionType,BookingCreator,moment, Brand) {
        return {
            restrict: 'E',
            scope: {
                dashboardView:'=dashboardView',
                reportView:'=reportView',
                position:'=position',
                taxMode:'=taxMode',
                isReportAlone:"=isReportAlone",
                onTaxModeChange:'&onTaxModeChange',
                onReportsBusinessSelected:'&onReportsBusinessSelected',
                onReportsCommunicateSelected:'&onReportsCommunicateSelected',
                onReportsDetailSelected:'&onReportsDetailSelected'
            },
            templateUrl: '/partials/statistics/report/report.html',
            controller: ['$scope', 'Images', function($scope, Images) {
                $scope.bookingStatusImage = Images.saleStatus;
                $scope.mouseover = false;
                $scope.TypeOfGraph = TypeOfGraph;
                $scope.ColorGraph = ColorGraph;
                $scope.EltReportType = EltReportType;
                $scope.DateFormator = DateFormator;
                $scope.categoryOver = null;
                $scope.PrimaryDatasType = PrimaryDatasType;
                $scope.primaryDataTypePeriodStat = null;
                $scope.StatPeriodType = StatPeriodType;
                $scope.ReportTemporalAgregateFunctionType = ReportTemporalAgregateFunctionType;
                $scope.periodType = PeriodType;
                $scope.TaxModeList = TaxMode;
                $scope.currencySymbol = CurrencyManager.getCurrencySymbol();
                $scope.ReportTotalAgregateFunctionType = ReportTotalAgregateFunctionType;
                $scope.BookingCreator = BookingCreator;
                $scope.brand = Brand;

                this.charts = new Array();
                var self = this;

                if($scope.reportView.getDataSource()) {

                    this.reportId = $scope.reportView.id;
                    this.typeOfData = $scope.reportView.typeOfData;

                    //if ($scope.reportView.getDataSource().selectedPastPeriod) {

                        $scope.dailyDatePicker = {
                            opened: false,
                            minDate: DayData.getByIndex(0).getDate(),
                            dateOptions: {
                                // 'year-format': "'yy'",
                                'starting-day': 1,
                                'datepickerMode': 'day'
                            }
                        };

                        $scope.monthlyDatePicker = {
                            opened: false,
                            minDate: DayData.getByIndex(0).getDate(),
                            dateOptions: {
                                // 'year-format': "'yy'",
                                'starting-day': 1,
                                'datepickerMode': 'month',
                                'minMode': 'month'
                            }
                        };

                        $scope.yearlyDatePicker = {
                            opened: false,
                            minDate: DayData.getByIndex(0).getDate(),
                            dateOptions: {
                                // 'year-format': "'yy'",
                                'starting-day': 1,
                                'datepickerMode': 'year',
                                'minMode': 'year'
                            }
                        };

                        $scope.pastPeriodBeginDatePicker = {
                            opened: false,
                            minDate: DayData.getByIndex(0).getDate(),
                            dateOptions: {
                                // 'year-format': "'yy'",
                                'starting-day': 1,
                                'datepickerMode': 'day'
                            }
                        };

                        $scope.pastPeriodEndDatePicker = {
                            opened: false,
                            minDate: DayData.getByIndex(0).getDate(),
                            dateOptions: {
                                // 'year-format': "'yy'",
                                'starting-day': 1,
                                'datepickerMode': 'day'
                            }
                        };
                    $scope.getReportDataSource = function () {
                        return $scope.reportView.getDataSource();
                    };

                    this.getReportDataSource = $scope.getReportDataSource;

                    $scope.onReportTitleDbClick = function(){
                        if($scope.dashboardView && $scope.dashboardView.hasReport($scope.reportView) && !$scope.dashboardView.isFlexy){
                            $scope.dashboardView.editing = true;
                        }
                    }

                    $scope.setCategoryOver = function (categoryOver) {
                        $scope.categoryOver = categoryOver;
                    };

                    this.setCategoryOver = $scope.setCategoryOver;

                    $scope.onCategoryDownClick = function (category, statPeriodTypeSelected, date) {
                        if ((statPeriodTypeSelected && category.getSubStatCategories &&
                            category.getSubStatCategories($scope.getReportDataSource().rootCategory, $scope.getReportDataSource().getPeriod(statPeriodTypeSelected).arrayOfDay) &&
                            category.getSubStatCategories($scope.getReportDataSource().rootCategory, $scope.getReportDataSource().getPeriod(statPeriodTypeSelected).arrayOfDay).length > 0) ||
                            $scope.reportView.hasPrimaryDatas()

                        ) {
                            $scope.getReportDataSource().addCategoryToCurrentPath(category);
                            $scope.getReportDataSource().loadCategory(category);
                            $scope.reportView.setPrimaryDataTypePeriodStat(statPeriodTypeSelected);
                            if(date) {
                                $scope.reportView.setPrimaryDataDay(DayData.getById(new moment(date).format('YYYYMMDD')));
                            }
                            else{
                                $scope.reportView.setPrimaryDataDay(null);
                            }
                        }
                    };

                    this.onCategoryDownClick = $scope.onCategoryDownClick;

                    $scope.onCategoryUpClick = function (category) {
                        $scope.getReportDataSource().updatePath(category);
                        $scope.getReportDataSource().loadCategory(category);
                    };

                    this.onCategoryUpClick = $scope.onCategoryUpClick;

                    $scope.displayReportDatePickerF = function (beginEnd) {

                        $timeout(function () {

                            var displayedDatePicker = null;

                            if ($scope.reportView.getDataSource().selectedPastPeriod.periodType === PeriodType.DAY ||
                                $scope.reportView.getDataSource().selectedPastPeriod.periodType === PeriodType.WEEK) {
                                displayedDatePicker = $scope.dailyDatePicker;
                            }
                            else if ($scope.reportView.getDataSource().selectedPastPeriod.periodType === PeriodType.MONTH) {
                                displayedDatePicker = $scope.monthlyDatePicker;
                            }
                            else if ($scope.reportView.getDataSource().selectedPastPeriod.periodType === PeriodType.YEAR) {
                                displayedDatePicker = $scope.yearlyDatePicker;
                            }
                            else if($scope.reportView.getDataSource().selectedPastPeriod.periodType === PeriodType.CUSTOMED){
                                if(beginEnd === "begin"){
                                    displayedDatePicker = $scope.pastPeriodBeginDatePicker;
                                }
                                else if(beginEnd === "end"){
                                    displayedDatePicker = $scope.pastPeriodEndDatePicker;
                                }
                            }

                            displayedDatePicker.date = $scope.reportView.getDataSource().selectedPastPeriod.beginMomentDay.clone().startOf('day').toDate();
                            displayedDatePicker.opened = true;
                        });
                    };

                    $scope.$watch('dailyDatePicker.date', function (date) {
                        if (date) {
                            //$scope.reportView.getDataSource().selectedPastPeriod = new PeriodStat(StatPeriodType.PAST, moment(date), $scope.reportView.getDataSource().currentPeriod.periodType);

                            var momentBeginPeriod = moment(date);

                            if($scope.reportView.getDataSource().currentPeriod.periodType === PeriodType.WEEK && !momentBeginPeriod.isSame(momentBeginPeriod.clone().startOf("week"))){
                                momentBeginPeriod.startOf("week");
                            }

                            $scope.reportView.getDataSource().selectedPastPeriod = new PeriodStat(
                                StatPeriodType.PAST,
                                momentBeginPeriod,
                                PeriodType.getLastDayOfPeriod($scope.reportView.getDataSource().currentPeriod.periodType, momentBeginPeriod, $scope.reportView.getDataSource().currentPeriod.arrayOfDays.length),
                                $scope.reportView.getDataSource().currentPeriod.periodType
                            );

                            $scope.reportView.getDataSource().loadPastPeriod();
                        }
                    });

                    $scope.$watch('monthlyDatePicker.date', function (date) {
                        if (date) {
                            //$scope.reportView.getDataSource().selectedPastPeriod = new PeriodStat(StatPeriodType.PAST, moment(date), $scope.reportView.getDataSource().currentPeriod.periodType);

                            $scope.reportView.getDataSource().selectedPastPeriod = new PeriodStat(
                                StatPeriodType.PAST,
                                moment(date),
                                PeriodType.getLastDayOfPeriod($scope.reportView.getDataSource().currentPeriod.periodType, moment(date), $scope.reportView.getDataSource().currentPeriod.arrayOfDays.length),
                                $scope.reportView.getDataSource().currentPeriod.periodType
                            );
                            $scope.reportView.getDataSource().loadPastPeriod();
                        }
                    });

                    $scope.$watch('yearlyDatePicker.date', function (date) {
                        if (date) {
                            //$scope.reportView.getDataSource().selectedPastPeriod = new PeriodStat(StatPeriodType.PAST, moment(date), $scope.reportView.getDataSource().currentPeriod.periodType);

                            $scope.reportView.getDataSource().selectedPastPeriod = new PeriodStat(
                                StatPeriodType.PAST,
                                moment(date),
                                PeriodType.getLastDayOfPeriod($scope.reportView.getDataSource().currentPeriod.periodType, moment(date), $scope.reportView.getDataSource().currentPeriod.arrayOfDays.length),
                                $scope.reportView.getDataSource().currentPeriod.periodType
                            );
                            $scope.reportView.getDataSource().loadPastPeriod();
                        }
                    });

                    $scope.$watch('pastPeriodBeginDatePicker.date', function (date) {
                        if (date) {
                            var momentDate = moment(date);


                            $scope.reportView.getDataSource().selectedPastPeriod = new PeriodStat(
                                StatPeriodType.PAST,
                                momentDate,
                                $scope.reportView.getDataSource().selectedPastPeriod.endMomentDay,
                                $scope.reportView.getDataSource().currentPeriod.periodType
                            );

                            $scope.reportView.getDataSource().loadPastPeriod();
                        }
                    });

                    $scope.$watch('pastPeriodEndDatePicker.date', function (date) {
                        if (date) {
                            var momentDate = moment(date);

                            $scope.reportView.getDataSource().selectedPastPeriod = new PeriodStat(
                                StatPeriodType.PAST,
                                $scope.reportView.getDataSource().selectedPastPeriod.beginMomentDay,
                                momentDate,
                                $scope.reportView.getDataSource().currentPeriod.periodType
                            );

                            $scope.reportView.getDataSource().loadPastPeriod();
                        }
                    });

                    $scope.exportExcel = function(objet, idTable, title){
                        return ExcellentExport.excel(objet, idTable, title);
                    };

                    $scope.exportCsv = function(objet, idTable){
                        return ExcellentExport.csv(objet, idTable);
                    };

                    $scope.setSelectionChartCategory = function(eltReportType, activeRepresentation, index){
                        try {
                            if (index != null) {
                                if (activeRepresentation == "pie-chart") {
                                    $scope.setSelectionChart(eltReportType, index, null);
                                }
                                else if (activeRepresentation == "column-chart") {
                                    $scope.setSelectionChart(eltReportType, index, 1);
                                }
                                else if (activeRepresentation == "stacked-column-chart" && eltReportType === EltReportType.COMPARE) {
                                    $scope.setSelectionChart(eltReportType, 1, (index * 2) + 1);
                                }
                                else if (activeRepresentation == "stacked-column-chart") {
                                    $scope.setSelectionChart(eltReportType, 1, index + 1);
                                }
                            }
                            else {
                                $scope.setSelectionChart(eltReportType, null, null);
                            }
                        }
                        catch(err){
                            console.warn("Erreur during the setSelectionChartCategory; " + err.message);
                        }
                    };

                    $scope.setSelectionChart = function(eltReportType, rowIndex, columnIndex){
                        if(rowIndex != null) {
                            if(columnIndex != null) {
                                self.charts[eltReportType].setSelection([{row: rowIndex, column: columnIndex}]);
                            }
                            else{
                                self.charts[eltReportType].setSelection([{row: rowIndex}]);
                            }
                        }
                        else{
                            self.charts[eltReportType].setSelection([{row: null}]);
                        }
                    };

                    $scope.onTaxModeClick = function(newTaxMode){
                        $scope.onTaxModeChange({newTaxMode:newTaxMode});
                    };

                    $scope.onReportsBusinessClick = function(businessPage){
                        $scope.onReportsBusinessSelected({reportView:$scope.reportView,businessPage:businessPage});
                        $timeout($scope.scrollTo,200);
                    };

                    $scope.isEnglishLanguage = function () {
                        return LanguageManager.isEnglishLanguage();
                    };

                    $scope.isFrenchLanguage = function(){
                        return LanguageManager.isFrenchLanguage();
                    };

                    $scope.onReportsCommunicateClick = function(){
                        $scope.onReportsCommunicateSelected({reportView:$scope.reportView});
                        $timeout($scope.scrollTo,200);
                    };
                    $scope.onReportsDetailClick = function(){
                        $scope.onReportsDetailSelected({reportView:$scope.reportView});
                        $timeout($scope.scrollTo,200);
                    };
                    $scope.scrollTo = function(){
                        // Get report number index+1 of report list and scroll to
                        var report = $("div.dashboard-reports-list flexy-report:nth-child(" + $scope.position + ")");
                        if (report && report.length>0)
                            $('.dashboard-reports-list').animate({scrollTop: report[0].offsetTop});
                    };

                    $scope.scrollDown = function () {
                        $timeout(function(){
                            var dashboardReportListDiv = $('.dashboard-reports-list');
                            if (dashboardReportListDiv && dashboardReportListDiv.length>0)
                            {
                                var height = dashboardReportListDiv[0].scrollHeight;
                                dashboardReportListDiv.animate({scrollTop: height});
                            }
                        },200);
                    };

                    $scope.getNbPrimaryDataOfType = function(type){
                        return $filter('filter')($scope.reportView.getDataSource().getCurrentPeriodStat().primaryDatas, function(primaryData){
                            var isOfGoodType = false;
                            if ($scope.PrimaryDatasType.getType(primaryData) === type) {
                                isOfGoodType = true;
                            }
                            return isOfGoodType;
                        }).length;
                    }
                }
                else{
                    console.info("DataSource non définie pour le rapport : " + $scope.reportView.id);
                }
            }]
        }
    }])
    .directive('flexyChart', ["ColorGraph", "EltReportType", "StatPeriodType", "$locale", "$filter", "CurrencyManager", function (ColorGraph,EltReportType,StatPeriodType,$locale,$filter,CurrencyManager) {
        return {
            restrict: 'E',
            scope: {
                eltReportView:      "=eltReportView",
                datas:              '=datas',
                categorieTable:     "=categorieTable"
            },
            require:                '^^flexyReport',
            link: function($scope, $elm, attrs, reportCtrl) {
                var chart = null,
                    isStacked = false,
                    dataTable = null;

                $scope.drawChart = function() {
                    var height = null,
                        //hAxis = {allowContainerBoundaryTextCufoff : false},
                        hAxis = {},
                        vAxis = {},
                        legend = { position: "none" },
                        chartArea = {width: '100%', height: '90%',top:'7.5%'},
                        viewWindow = {},
                        colors = new Array(),
                        toolTypeIsHtml = true;

                    $scope.eltReportView.activeRepresentation = $scope.eltReportView.representation;

                    if($scope.datas.datasChart.length != 0) {

                        dataTable = google.visualization.arrayToDataTable($scope.datas.datasChart);

                        if($scope.categorieTable) {
                            for (var i = 0; i < $scope.categorieTable.length; i++) {
                                colors.push($scope.categorieTable[i].color);
                            }
                        }

                        if ($scope.eltReportView.representation == "table") {
                            chart = new google.visualization.Table($elm[0]);
                        }
                        else if ($scope.eltReportView.representation == "pie-chart" || (reportCtrl.typeOfData == "percent" && dataTable.getNumberOfRows() == 1 && EltReportType.getEltReportTypeById($scope.eltReportView.type) === EltReportType.TOTALISE)) {
                            chart = new google.visualization.PieChart($elm[0]);

                            if($scope.eltReportView.representation != "pie-chart"){
                                $scope.eltReportView.activeRepresentation = "pie-chart" ;

                                var tooltipValue = "";//tooltip set to an empty string because this category is not usefull for the final user and beacuse technically, we have no libelle for the category
                                dataTable.addRow(['', 100 - dataTable.getValue(0, 1), "#f5f5f5", tooltipValue]);
                                colors.push("#f5f5f5");
                            }
                        }
                        else if ($scope.eltReportView.representation == "column-chart" || $scope.eltReportView.representation == "stacked-column-chart") {
                            chart = new google.visualization.ColumnChart($elm[0]);
                            chartArea.top = '15px';
                            if (EltReportType.getEltReportTypeById($scope.eltReportView.type) != EltReportType.ZOOM) {
                                chartArea.width = '85%';
                                chartArea.left = '15%';
                                chartArea.height = '75%';
                            }
                            else {
                                chartArea.width = '90%';
                                chartArea.left = '7%';
                                chartArea.height = '70%';
                            }
                            if($scope.datas.tickLabels && $scope.eltReportView.representation == "stacked-column-chart") {
                                hAxis.minValue = 0.75;
                                hAxis.maxValue = 2;
                                hAxis.ticks = $scope.datas.tickLabels;
                            }
                            if(dataTable.getNumberOfRows() > 4){
                                hAxis.slantedText = true;
                                //hAxis.slantedTextAngle = 90;

                                hAxis.gridlines={count:dataTable.getNumberOfRows()}
                                hAxis.gridlines.color ='#f4f4f4';
                                hAxis.textStyle = {fontSize: 8}
                            }
                            if(reportCtrl.typeOfData == "time"){
                                vAxis.format = '#,### h';
                                vAxis.minValue = 0;
                            }

                            if(dataTable.getColumnType(0) == "date"){
                                hAxis.format =  $locale.DATETIME_FORMATS.shortDate;

                                //strange case : when we have only one date, google chart don't display well the hAxes and we have to fixe the viewWindows
                                if(dataTable.getNumberOfRows() == 1){
                                    hAxis.viewWindow =  {
                                        min: new Date(dataTable.getValue(0,0).getTime() - 24 * 60 * 60 * 1000),
                                        max: new Date(dataTable.getValue(0,0).getTime() + 24 * 60 * 60 * 1000)
                                    }
                                }
                            }

                            //in compare mode we need to manage ourself the hAxis
                            if (EltReportType.getEltReportTypeById($scope.eltReportView.type) == EltReportType.COMPARE){
                                hAxis.textPosition = 'none';
                                hAxis.opt_axis_or_tick = '_';
                            }

                             if (reportCtrl.typeOfData == "percent") {
                                 vAxis = {
                                     minValue: 0,
                                     maxValue: 100,
                                     format:"##'%'"
                                 };

                                 var formatter = new google.visualization.NumberFormat({
                                     fractionDigits: 2,
                                     suffix: '%'
                                 });

                                 formatter.format(dataTable, 1);
                            }
                            else if($scope.eltReportView.representation == "stacked-column-chart"){
                                isStacked = true
                            }
                        }

                        var toolip = {trigger: 'selection', isHtml:toolTypeIsHtml};
                        if (EltReportType.getEltReportTypeById($scope.eltReportView.type) == EltReportType.ZOOM)
                            toolip.trigger = 'focus';

                        let trendlines = {},
                            finalHeight,
                            screenWith = $(window).width(),
                            finalWidth = $($elm[0]).parent().width();

                        if (screenWith < 600) {//FOR MOBILE
                            finalHeight = finalWidth*0.9;
                            if ($scope.eltReportView.representation == "pie-chart") {
                                chartArea.width = '80%';
                            }
                        }
                        else {
                            // TODO MANAGE DYNAMICALLY
                            var addWindow = $("div.dashboard-choice-form.active");//try to get a dashboard-choice-form.active to force with
                            if (addWindow && addWindow.length>0)
                            {
                                finalWidth = addWindow[0].offsetWidth - 65;//TODO set dynamic
                                if (EltReportType.getEltReportTypeById($scope.eltReportView.type) != EltReportType.ZOOM)
                                    finalWidth = finalWidth/2;//50% of width
                            }
                            finalHeight = 235; //FORCE HEIGHT

                        }
                        var options = {
                            width : finalWidth,
                            height: finalHeight,
                            isStacked : isStacked,
                            pieHole: 0.7,
                            legend: legend,
                            hAxis : hAxis,
                            vAxis : vAxis,
                            chartArea: chartArea,
                            trendlines: trendlines,
                            pieSliceText : 'none',
                            tooltip : toolip,
                            gridlines: {
                                units: {
                                    years: {format: ['yyyy']},
                                    months: {format: ['MM']},
                                    days: {format: ['d']}
                                }
                            },
                            colors:colors.length != 0?colors : ColorGraph.colors,
                            pieStartAngle:-90
                        };

                        google.visualization.events.addListener(chart, 'error', function (googleError) {
                            google.visualization.errors.removeError(googleError.id);
                        });

                        // Chart selection handler
                        google.visualization.events.addListener(chart, 'select', function () {
                            var selectedItem = chart.getSelection()[0];
                            if (selectedItem) {
                                var row = selectedItem.row,
                                    column = selectedItem.column,
                                    category = null;
                                if ($scope.eltReportView.activeRepresentation == "pie-chart" || $scope.eltReportView.activeRepresentation == "column-chart"){
                                    column = 0;
                                    var value = dataTable.getValue(row, column);
                                    category = reportCtrl.getReportDataSource().getCategoryByLabel(value);
                                }
                                else {
                                    category = reportCtrl.getReportDataSource().getCategoryByLabel(dataTable.getColumnLabel(column));
                                }

                                var typePeriodStatSelected = StatPeriodType.CURRENT;
                                if (EltReportType.getEltReportTypeById($scope.eltReportView.type) == EltReportType.COMPARE){
                                    if(row == 0){
                                        typePeriodStatSelected = StatPeriodType.PAST;
                                    }
                                }

                                if(category){
                                    reportCtrl.onCategoryDownClick(category, typePeriodStatSelected, (dataTable.getValue(row, 0) && dataTable.getValue(row, 0) instanceof Date)?dataTable.getValue(row, 0):null );
                                    $scope.$apply();
                                }
                            }
                        });

                        google.visualization.events.addListener(chart, 'onmouseover', function(overItem) {
                            if (overItem) {
                                var row = overItem.row,
                                    column = overItem.column,
                                    categoryOver = null;

                                if ($scope.eltReportView.activeRepresentation == "pie-chart") {
                                    column = 0;
                                    var value = dataTable.getValue(row, column);
                                    categoryOver = reportCtrl.getReportDataSource().getCategoryByLabel(value);
                                }
                                else {
                                    categoryOver = reportCtrl.getReportDataSource().getCategoryByLabel(dataTable.getColumnLabel(column));
                                }

                                reportCtrl.setCategoryOver(categoryOver);
                                $scope.$apply();
                            }
                        });

                        google.visualization.events.addListener(chart, 'onmouseout', function(overItem) {
                            reportCtrl.setCategoryOver(null);
                            $scope.$apply();
                        });

                        chart.draw(dataTable, options);

                        if(reportCtrl.charts) {
                            reportCtrl.charts[EltReportType.getEltReportTypeById($scope.eltReportView.type)] = chart;
                        }
                        else{
                            console.error("Erreur lors de la génération du graphique " + $scope.eltReportView.type + " du rapport " + reportCtrl.reportId);
                        }
                    }
                };

                // Watches, to refresh the chart when its data, title or dimensions change
                $scope.$watch('datas', function() {
                    $scope.drawChart();
                }, true);

                $scope.$watch('eltReportView.representation', function() {
                    $scope.drawChart();
                }, true); // true is for deep object equality checking

                $scope.$on('$destroy', function() {
                    chart.clearChart();
                });

                $scope.drawChart();
            },
            controller: ['$scope', function($scope) {
            }]
        };
    }])

    .directive('colsChart', ["ColorGraph", function (ColorGraph) {
        return {
            restrict: 'EA',
            scope: {
                chartId:    '@chartid',
                data:     '=data',
                maxValue: '@maxvalue',
                dateFormat: '@dateFormat',
                typeOfData: '@typeOfData',
                height: '@height',
                colors: '=colors',
                selectFn: '&select'
            },
            link: function($scope, $elm) {
                var chart = new google.visualization.ColumnChart($elm[0]);
                google.visualization.events.addListener(chart, 'error', function (googleError) {
                    google.visualization.errors.removeError(googleError.id);
                });
                $scope.drawChart = function()
                {
                    var dataTable = google.visualization.arrayToDataTable($scope.data);

                    // get width from the parent div one to fill in max the div
                    var parentWidth = $( $elm[0] ).parent().parent().css("width"); // .parent().parent() : get good div (class="row") in the DOM (cf dashboard.html)
                    var width = parseInt(parentWidth.substr(0,parentWidth.length-2)); // "1145px" -> 1145

                    var height = $(window).height() * 2 / 3;
                    if ($scope.height)
                        height =$scope.height;


                    var hAxis = {},
                        vAxis = {},
                        legend = { position: "none" },
                        chartArea = {width: '100%', height: '90%',top:'8%'},
                        viewWindow = {},
                        colors = new Array(),
                        trendlines = {},
                        toolip = {trigger: 'selection'};

                    chartArea.top = '10px';
                    chartArea.width = '80%';
                    chartArea.left = '0px';
                    chartArea.height = '70%';

                    if(dataTable.getNumberOfRows() > 4){

                        hAxis.gridlines={count:dataTable.getNumberOfRows()}
                        hAxis.gridlines.color ='#f4f4f4';
                        hAxis.textStyle = {fontSize: 10}
                    }

                    if(dataTable.getColumnType(0) == "date" && $scope.dateFormat){
                        hAxis.format= $scope.dateFormat;

                        //strange case : when we have only one date, google chart don't display well the hAxes and we have to fixe the viewWindows
                        if(dataTable.getNumberOfRows() == 1){
                            hAxis.viewWindow =  {
                                min: new Date(dataTable.getValue(0,0).getTime() - 24 * 60 * 60 * 1000),
                                max: new Date(dataTable.getValue(0,0).getTime() + 24 * 60 * 60 * 1000)
                            }
                        }
                    }

                    var options = {
                        width : width * 3 / 5,
                        height: height,
                        legend: { position: "none" },
                        hAxis : hAxis,
                        vAxis : vAxis,
                        chartArea: chartArea,
                        trendlines: trendlines,
                        pieSliceText : 'none',
                        tooltip : toolip,
                        gridlines: {
                            units: {
                                years: {format: ['yyyy']},
                                months: {format: ['MM']},
                                days: {format: ['d']}
                            }
                        },
                        colors:$scope.colors?$scope.colors:ColorGraph.colors,
                        pieStartAngle:-90
                    };

                    if ($scope.typeOfData == "currency") {
                        var currencyFormater = new google.visualization.NumberFormat({suffix: ' €'});
                        for (var i = 1; i < dataTable.getNumberOfColumns(); i++) {
                            currencyFormater.format(dataTable, i);
                        }
                    }

                    chart.draw(dataTable, options);
                };

                // Watches, to refresh the chart when its data, title or dimensions change
                $scope.$watch('data', function() {
                    $scope.drawChart();
                }, true); // true is for deep object equality checking

                // Chart selection handler
                /*google.visualization.events.addListener(chart, 'select', function () {
                    var selectedItem = chart.getSelection()[0];
                    if (selectedItem) {
                        $scope.$apply(function () {
                            $scope.selectFn({chartId: parseInt($scope.chartId)});
                        });
                    }
                });*/

                $scope.drawChart();
            }
        };
    }])
    .directive('pieChart', function () {
        return {
            restrict: 'EA',
            scope: {
                data:     '=data',
                selectFn: '&select'
            },
            link: function($scope, $elm) {
                var chart = new google.visualization.PieChart($elm[0]);
                google.visualization.events.addListener(chart, 'error', function (googleError) {
                    google.visualization.errors.removeError(googleError.id);
                });
                $scope.drawChart = function()
                {
                    var data = google.visualization.arrayToDataTable($scope.data);

                    // get width from the parent div one to fill in max the div
                    var parentWidth = $( $elm[0] ).parent().css("width");
                    var width = parseInt(parentWidth.substr(0,parentWidth.length-2));

                    var height = $(window).height() / 2;

                    if(width < height)
                        height = width;

                    var options = {
                        title: "",
                        width: width,
                        height: height,
                        pieSliceText: 'label',
                        pieSliceTextStyle: { fontSize: 12 },
                        chartArea: { width: '90%', height: '90%' }
                    };

                    chart.draw(data, options);
                };

                // Watches, to refresh the chart when its data, title or dimensions change
                $scope.$watch('data', function() {
                    $scope.drawChart();
                }, true); // true is for deep object equality checking

                // Chart selection handler
                google.visualization.events.addListener(chart, 'select', function () {
                    var selectedItem = chart.getSelection()[0];
                    if (selectedItem) {
                        $scope.$apply(function () {
                            $scope.selectFn({selectedRowIndex: selectedItem.row+1});
                        });
                    }
                });

                $scope.drawChart();
            }
        };
    })
    .directive('pieChartPos', function () {
        return {
            restrict: 'EA',
            scope: {
                data:     '=data',
                color:     '=color',
                selectFn: '&select'
            },
            link: function($scope, $elm) {
                var chart = new google.visualization.PieChart($elm[0]);
                google.visualization.events.addListener(chart, 'error', function (googleError) {
                    google.visualization.errors.removeError(googleError.id);
                });
                $scope.drawChart = function()
                {
                    // get width from the parent div one to fill in max the div
                    var parentWidth = $( $elm[0] ).parent().css("width");
                    var width = parseInt(parentWidth.substr(0,parentWidth.length-2));

                    var slicesColor = [];
                    if($scope.color != undefined && $scope.color != null)
                        for(var i=0; i<$scope.color.length; i++)
                            slicesColor.push({color:$scope.color[i]});

                    var data = google.visualization.arrayToDataTable($scope.data);
                    var options = {
                        legend : {position:'right',maxLines:10,alignment:'center',textStyle: {fontSize: 13}},
                        title: "",
                        slices: slicesColor,
                        width: width,
                        height: 280,
                        pieHole: 0.4,
                        pieSliceText: 'none',
                            pieSliceTextStyle: { fontSize: 12 },
                            chartArea: { left:0,width: '90%', height: '100%' }
                    };

                    chart.draw(data, options);
                };

                // Watches, to refresh the chart when its data, title or dimensions change
                $scope.$watch('data', function() {
                    $scope.drawChart();
                }, true); // true is for deep object equality checking

                // Chart selection handler
                google.visualization.events.addListener(chart, 'select', function () {
                    var selectedItem = chart.getSelection()[0];
                    if (selectedItem) {
                        $scope.$apply(function () {
                            $scope.selectFn({selectedRowIndex: selectedItem.row+1});
                        });
                    }
                });

                $scope.drawChart();
            }
        };
    })
    .directive('pieChartCategories', function () {
        return {
            restrict: 'EA',
            scope: {
                data:      '=data',
                color:     '=color',
                selectFn:  '&select',
                sourceTree:'=sourcetree'
            },
            link: function($scope, $elem) {
                var chart = new google.visualization.PieChart($elem[0]);
                google.visualization.events.addListener(chart, 'error', function (googleError) {
                    google.visualization.errors.removeError(googleError.id);
                });
                $scope.drawChart = function()
                {
                    var data = google.visualization.arrayToDataTable($scope.data);

                    var slicesColor = [];

                    if($scope.color != undefined && $scope.color != null)
                        for(var i=0; i<$scope.color.length; i++)
                            slicesColor.push({color:$scope.color[i]});

                    // get width from the parent div one to fill in max the div
                    var parentWidth = $( $elem[0] ).parent().css("width");
                    var width = parseInt(parentWidth.substr(0,parentWidth.length-2));

                    var height = $(window).height() / 2;

                    if(width < height)
                        height = width;

                    var options = {
                        title: "",
                        slices: slicesColor,
                        width: width,
                        height: height,
                        pieSliceText: 'label',
                        pieSliceTextStyle: { fontSize: 12 },
                        chartArea: { width: '90%', height: '90%' }
                    };

                    chart.draw(data, options);
                };

                // Watches, to refresh the chart when its data, title or dimensions change
                $scope.$watch('data', function() {
                    $scope.drawChart();
                }, true); // true is for deep object equality checking

                // Chart selection handler
                google.visualization.events.addListener(chart, 'select', function () {
                    var selectedItem = chart.getSelection()[0];
                    if (selectedItem) {
                        $scope.$apply(function () {
                            $scope.selectFn({selectedRowIndex: selectedItem.row, source: $scope.sourceTree});
                        });
                    }
                });

                $scope.drawChart();
            }
        };
    })
    .directive('barChart', function () {
        return {
            restrict: 'EA',
            scope: {
                width:     '@width',
                height:    '@height',
                vAxisTitle:'@titlevaxis',
                hAxisTitle:'@titlehaxis',
                data:      '=data',
                selectFn:  '&select'
            },
            link: function($scope, $elm) {
                var chart = new google.visualization.BarChart($elm[0]);
                google.visualization.events.addListener(chart, 'error', function (googleError) {
                    google.visualization.errors.removeError(googleError.id);
                });
                $scope.drawChart = function()
                {
                    var data = google.visualization.arrayToDataTable($scope.data);

                    var h = $scope.data.length * 30;
                    var screenH = $(window).height() /2;
                    if(h > screenH)
                        $scope.height = h;
                    else
                        $scope.height = screenH;

                    var options = {
                        title: "",
                        vAxis: {title: $scope.vAxisTitle, titleTextStyle: {color: 'red'}},
                        hAxis: {title: $scope.hAxisTitle, maxValue: 100, minValue: 0, titleTextStyle: {color: 'red'}},
                        width: $scope.width,
                        height: $scope.height,
                        bar: {groupWidth: "75%"},
                        chartArea: { width: '60%', height: '90%', top:10, right:10 },
                        legend: "none"
                    };

                    chart.draw(data, options);
                };

                // Watches, to refresh the chart when its data, title or dimensions change
                $scope.$watch('data', function() {
                    $scope.drawChart();
                }, true); // true is for deep object equality checking

                // Chart selection handler
                google.visualization.events.addListener(chart, 'select', function () {
                    var selectedItem = chart.getSelection()[0];
                    if (selectedItem) {
                        $scope.$apply(function () {
                            $scope.selectFn({selectedRowIndex: selectedItem.row});
                        });
                    }
                });

                $scope.drawChart();
            }
        };
    })
    .directive('barChartStacked', ['ColorGraph', function (ColorGraph) {
        return {
            restrict: 'EA',
            scope: {
                vAxisTitle:'@titlevaxis',
                hAxisTitle:'@titlehaxis',
                data:      '=data',
                selectFn:  '&select'
            },
            link: function($scope, $elm) {
                var chart = new google.visualization.BarChart($elm[0]);
                google.visualization.events.addListener(chart, 'error', function (googleError) {
                    google.visualization.errors.removeError(googleError.id);
                });
                $scope.drawChart = function()
                {
                    var data = google.visualization.arrayToDataTable($scope.data);

                    var max = 0;
                    for(var i=1; i<$scope.data.length; i++)
                    {
                        if($scope.data[i][1] + $scope.data[i][4] > max)
                            max = Math.round($scope.data[i][1] + $scope.data[i][4]);
                    }
                    var screenH = $(window).height() /2;

                    // get width from the parent div one to fill in max the div
                    var parentWidth = $( $elm[0] ).parent().parent().css("width"); // .parent().parent() : get good div (class="row") in the DOM (cf dashboard.html)
                    var width = parseInt(parentWidth.substr(0,parentWidth.length-2))-20; // "1145px" -> 1145

                    var options = {
                        title: "",
                        vAxis: {title: $scope.vAxisTitle, titleTextStyle: {color: 'red'}},
                        hAxis: {title: $scope.hAxisTitle, titleTextStyle: {color: 'red'}, maxValue: max, gridlines: {count: 6}},
                        width: width,
                        height: screenH,
                        bar: {groupWidth: "75%"},
                        chartArea: { width: '70%', height: '85%', top:10, right:10 },
                        isStacked: true,
                        colors:ColorGraph.colors,
                    };
                    /*var options = {
                        title: "",
                        titleTextStyle: {
                            color: "",
                            fontName: "",
                            fontSize: 15,
                            bold: true,
                            italic: true
                        },
                        tooltip: {
                            trigger: 'none'
                        },
                        width: width/3,
                        height: height,
                        bar: { groupWidth: "90%" },
                        legend: { position: "none" },
                        vAxis: {
                            maxValue: max,
                            minValue: 0,
                            textStyle: {
                                color: "",
                                fontName: "",
                                fontSize: 13,
                                bold: false,
                                italic: false
                            }
                        },
                        hAxis: {
                            textStyle: {
                                color: "",
                                fontName: "",
                                fontSize: 13,
                                bold: false,
                                italic: false
                            }
                        },
                        chartArea: { width: '60%', height: '80%' }
                        /!*,
                         animation: {
                         duration: 1000,
                         easing: 'inAndOut'
                         }*!/
                    };*/

                    chart.draw(data, options);
                };
                // Watches, to refresh the chart when its data, title or dimensions change
                $scope.$watch('data', function() {
                    $scope.drawChart();
                }, true); // true is for deep object equality checking

                // Chart selection handler
                google.visualization.events.addListener(chart, 'select', function () {
                    var selectedItem = chart.getSelection()[0];
                    if (selectedItem) {
                        $scope.$apply(function () {
                            $scope.selectFn({selectedRowIndex: selectedItem.row});
                        });
                    }
                });
                $scope.drawChart();
            }
        };
    }])
   .directive('onLongPress', ['$timeout', function($timeout) {
        return {
            restrict: 'A',
            link: function($scope, $elm, $attrs) {
                $elm.bind('touchstart', function(evt) {
                    // Locally scoped variable that will keep track of the long press
                    $scope.longPress = true;

                    // We'll set a timeout for 600 ms for a long press
                    $timeout(function() {
                        if ($scope.longPress) {
                            // If the touchend event hasn't fired,
                            // apply the function given in on the element's on-long-press attribute
                            $scope.$apply(function() {
                                $scope.$eval($attrs.onLongPress)
                            });
                        }
                    }, 600);
                });

                $elm.bind('touchend', function(evt) {
                    // Prevent the onLongPress event from firing
                    $scope.longPress = false;
                    // If there is an on-touch-end function attached to this element, apply it
                    if ($attrs.onTouchEnd) {
                        $scope.$apply(function() {
                            $scope.$eval($attrs.onTouchEnd)
                        });
                    }
                });
            }
        };
   }])
    .directive('companyModelInput', ['gettextCatalog', function (gettextCatalog) {
        return {
            restrict: 'E',
            scope: {
                startModel : '=startModel',
                startModelLabel : "=?startModelLabel",
            },
            templateUrl: '/partials/group/company/companyModelInput.html',
            link: function($scope) {
                $scope.onModelChange = function(){
                    if(!$scope.startModelLabel && $scope.startModelLabel !== '')
                        switch ($scope.startModel) {
                            case "flexymodel1":  $scope.startModelLabel = gettextCatalog.getString("Salon de coiffure");
                                break;
                            case "flexymodel2":  $scope.startModelLabel = gettextCatalog.getString("Institut de beauté");
                                break;
                            case "flexymodel3":  $scope.startModelLabel = gettextCatalog.getString("Spa");
                                break;
                            case "flexymodel5":  $scope.startModelLabel = gettextCatalog.getString("Salon de coiffure l'Oréal");
                                break;
                            default: $scope.startModelLabel = gettextCatalog.getString("Autre");
                                break;
                        }
                }
            }
        }
    }])
    .directive("tooltipsModal", function() {
        return {
            restrict: 'E',
            scope: {
                position: '@tooltipsPosition',
                title: '@tooltipsTitle',
                description: '@tooltipsDescription',
                picture: '@tooltipsPicture',
                button: '@tooltipsButton',
                ngClick: '&tooltipsNgClick'
            },
            templateUrl: '/partials/flexyBeauty/dialog/tooltips.html',
        }
    })
    .directive('techNoteTable', [function () {
        return {
            restrict: 'E',
            scope: {
                itemView: '=itemView',
                pTView: '=pTView',
                posView: '=posView',
                customerView: '=customerView'
            },
            templateUrl: '/partials/planningPos/customer/techNoteTable.html',
            controller: ['$scope', "Images", function ($scope, Images) {
                $scope.bookingStatusImage = Images.saleStatus;
                $scope.showBookingOrSale = function (bookingOrSaleView) {
                    if (!$scope.itemView) {
                        if (bookingOrSaleView.isBooking) {
                            $scope.pTView.setAndDisplayEditedBookingViewFromIndex(bookingOrSaleView.index)
                        } else {
                            $scope.posView.setEditedSaleViewFromIndex(bookingOrSaleView.index)
                        }
                    }
                };
            }]
        };
    }])
    .directive('customerForm', ["Brand", function (Brand) {
        return {
            restrict: 'E',
            scope: {
                customer: '=customer',
                isReadOnly: '=isReadOnly',
                onlineReservationAccess: '=onlineReservationAccess',
                clientFullAccess: '=clientFullAccess',
                customClass: '@customClass',
                cancel: '&cancel',
                save: '&save'
            },
            templateUrl: '/partials/planningPos/customer/customerForm.html',
            controller: ['$scope', function ($scope) {
                $scope.dateOptions = {
                    startingDay: 1,
                    datepickerMode: 'day',
                    language: 'fr'
                };
                $scope.displayErrorMobile = false;
                $scope.displayErrorLandline = false;
                $scope.dateOpened = false;
                $scope.brand = Brand;

                $scope.toggleOpened = function () {
                    $scope.dateOpened = !$scope.dateOpened;
                };

                $scope.onCancel = function () {
                    $scope.cancel();
                };

                $scope.onSave = function () {
                    if ($scope.customerForm.$valid && !$scope.displayErrorMobile && !$scope.displayErrorLandline) {
                        $scope.save();
                    }
                };
            }]
        };
    }]);



// WEBPACK FOOTER //
// ./js/directives/directivesPro.js